import { render } from "./AgePage.vue?vue&type=template&id=094d9abc&scoped=true"
import script from "./AgePage.vue?vue&type=script&lang=js"
export * from "./AgePage.vue?vue&type=script&lang=js"

import "./AgePage.vue?vue&type=style&index=0&id=094d9abc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-094d9abc"]])

export default __exports__